/** 3D 模型预览（ThreeViewer）文案，与 OEM multilang 中同名 key 对齐 */
export default {
	"zh-CN": {
		loading: "加载中",
		format: "格式",
		vertexCount: "顶点数",
		size: "尺寸",
		materialCount: "材质数",
		mtlMaterial: "MTL材质",
		associated: "已关联",
		notAssociated: "未关联",
		retry: "重试加载",
		dragHint: "释放文件以加载模型"
	},
	"zh-TW": {
		loading: "載入中",
		format: "格式",
		vertexCount: "頂點數",
		size: "尺寸",
		materialCount: "材質數",
		mtlMaterial: "MTL材質",
		associated: "已關聯",
		notAssociated: "未關聯",
		retry: "重試載入",
		dragHint: "釋放檔案以載入模型"
	},
	"zh-HK": {
		loading: "載入中",
		format: "格式",
		vertexCount: "頂點數",
		size: "尺寸",
		materialCount: "材質數",
		mtlMaterial: "MTL材質",
		associated: "已關聯",
		notAssociated: "未關聯",
		retry: "重試載入",
		dragHint: "釋放檔案以載入模型"
	},
	en: {
		loading: "Loading",
		format: "Format",
		vertexCount: "Vertex Count",
		size: "Size",
		materialCount: "Material Count",
		mtlMaterial: "MTL Material",
		associated: "Associated",
		notAssociated: "Not Associated",
		retry: "Retry Loading",
		dragHint: "Release file to load model"
	},
	ja: {
		loading: "読み込み中",
		format: "形式",
		vertexCount: "頂点数",
		size: "サイズ",
		materialCount: "マテリアル数",
		mtlMaterial: "MTLマテリアル",
		associated: "関連付け済み",
		notAssociated: "未関連",
		retry: "再読み込み",
		dragHint: "ファイルをドロップしてモデルを読み込む"
	},
	ko: {
		loading: "로딩 중",
		format: "형식",
		vertexCount: "정점 수",
		size: "크기",
		materialCount: "재질 수",
		mtlMaterial: "MTL 재질",
		associated: "연결됨",
		notAssociated: "연결 안 됨",
		retry: "다시 로드",
		dragHint: "파일을 놓아 모델을 로드하세요"
	},
	es: {
		loading: "Cargando",
		format: "Formato",
		vertexCount: "Número de vértices",
		size: "Tamaño",
		materialCount: "Número de materiales",
		mtlMaterial: "Material MTL",
		associated: "Asociado",
		notAssociated: "No asociado",
		retry: "Reintentar carga",
		dragHint: "Suelta el archivo para cargar el modelo"
	}
};
